export default __webpack_public_path__ + "static/media/staccata.a7b06601.png";